import { render, staticRenderFns } from "./SupportCategoryViewInfo.vue?vue&type=template&id=2d66df5b&"
import script from "./SupportCategoryViewInfo.vue?vue&type=script&lang=js&"
export * from "./SupportCategoryViewInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports